/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ComplianceTimelineEventType = {
    BankAccount: 'BANK_ACCOUNT',
    CompanyType: 'COMPANY_TYPE',
    ExternalStatus: 'EXTERNAL_STATUS',
    Fraud: 'FRAUD',
    InternalStatus: 'INTERNAL_STATUS',
    KycDocument: 'KYC_DOCUMENT',
    KycStatus: 'KYC_STATUS',
    LegalAgreement: 'LEGAL_AGREEMENT',
    Rqth: 'RQTH',
    Ubo: 'UBO',
    Umbrella: 'UMBRELLA',
    User: 'USER'
} as const;
export type ComplianceTimelineEventType = typeof ComplianceTimelineEventType[keyof typeof ComplianceTimelineEventType];


export function instanceOfComplianceTimelineEventType(value: any): boolean {
    for (const key in ComplianceTimelineEventType) {
        if (Object.prototype.hasOwnProperty.call(ComplianceTimelineEventType, key)) {
            // @ts-ignore
            if (ComplianceTimelineEventType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComplianceTimelineEventTypeFromJSON(json: any): ComplianceTimelineEventType {
    return ComplianceTimelineEventTypeFromJSONTyped(json, false);
}

export function ComplianceTimelineEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceTimelineEventType {
    return json as ComplianceTimelineEventType;
}

export function ComplianceTimelineEventTypeToJSON(value?: ComplianceTimelineEventType | null): any {
    return value as any;
}

